import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiPaginationResponse, ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  AddPackagePayload,
  ConfirmEecsPackagePaymentPayload,
  FetchPackagesPayload,
  IEecsPackage,
  UpdatePackagePayload,
} from '../types/eecs-package.types';

export const eecsPackageApi = createApi({
  reducerPath: 'eecsPackageApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/necs/go-packages`),
  endpoints: (builder) => ({
    fetchPackages: builder.query<ApiPaginationResponse<IEecsPackage[]>, FetchPackagesPayload>({
      query: (payload) => ({
        url: ``,
        method: 'GET',
        params: payload,
      }),
    }),
    addPackage: builder.mutation<ApiResponse<any>, AddPackagePayload>({
      query: (payload) => ({
        url: ``,
        method: 'POST',
        body: payload,
      }),
    }),
    updatePackage: builder.mutation<ApiResponse<IEecsPackage>, UpdatePackagePayload>({
      query: (payload) => ({
        url: `${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
    }),
    confirmPackagePayment: builder.mutation<ApiResponse<void>, ConfirmEecsPackagePaymentPayload>({
      query: (payload) => ({
        url: `/${payload.id}/payment/confirm`,
        method: 'PUT',
        body: payload,
      }),
    }),
  }),
});

export const {
  useLazyFetchPackagesQuery,
  useUpdatePackageMutation,
  useAddPackageMutation,
  useConfirmPackagePaymentMutation,
} = eecsPackageApi;
